// extracted by mini-css-extract-plugin
module.exports = {"wrap":"GNB_wrap__28vku","text":"GNB_text__2RySi"};